'use client';

import React from 'react';
import * as RadixTooltip from '@radix-ui/react-tooltip';
import styled from 'styled-components';

export interface TooltipProps {
  content: React.ReactNode;
  side?: 'top' | 'right' | 'bottom' | 'left';
  delayDuration?: number;
  children: React.ReactElement;
}

const Content = styled(RadixTooltip.Content)`
  padding: ${(p) => p.theme.spaceAlias.xs} ${(p) => p.theme.spaceAlias.sm};
  background: ${(p) => p.theme.colors.neutral.ink};
  color: ${(p) => p.theme.colors.neutral.bg};
  font-family: ${(p) => p.theme.fontFamily.ui};
  font-size: ${(p) => p.theme.fontSize.sm};
  font-weight: ${(p) => p.theme.fontWeight.medium};
  border-radius: ${(p) => p.theme.radius.md};
  line-height: 1.4;
  max-width: 220px;
  box-shadow: ${(p) => p.theme.elevation.overlay.shadow};
  z-index: ${(p) => p.theme.zIndex.tooltip};
  user-select: none;
`;

export function Tooltip({ content, side = 'top', delayDuration = 300, children }: TooltipProps) {
  return (
    <RadixTooltip.Provider delayDuration={delayDuration}>
      <RadixTooltip.Root>
        <RadixTooltip.Trigger asChild>{children}</RadixTooltip.Trigger>
        <RadixTooltip.Portal>
          <Content side={side} sideOffset={4}>
            {content}
          </Content>
        </RadixTooltip.Portal>
      </RadixTooltip.Root>
    </RadixTooltip.Provider>
  );
}
